module.exports = __webpack_public_path__ + "img/RS_changeDetection-4.bc6fb3fe.png";